<template>
  <b-container class="business-list">
    <b-row>
      <b-col
        col
        lg="3">
        <router-link
          :to="{ name: 'ConfirmBusinessPage' }"
          tag="div"
          class="business-list__merchant-box">
          <img
            class="business-list__plus-icon"
            src="~@/assets/img/add-icon.svg"
            alt="Add business">
          <div class="business-list__title">
            Add New Business
          </div>
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'BusinessListPage',
};
</script>
